import ForgotPasswordForm from 'components/modules/auth/ForgotPassword/ForgotPasswordForm';
import AuthCardLayout from 'layouts/AuthCardLayout';
import React from 'react';

const ForgotPassword = () => {
  return (
    <div>
      <AuthCardLayout className="pb-md-7">
        <ForgotPasswordForm />
      </AuthCardLayout>
    </div>
  );
};

export default ForgotPassword;
